import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsUserAgent } from '../../../../packages/Filters/shared/selectors';
import { selectProfessionalSearchUrl } from '../../../selectors/selectProfessionalSearchUrl';
import { DownloadExcelButton } from './components/DownloadExcelButton';
import { DownloadExcelModalRealtors, DownloadExcelModalSearchers } from './components/DownloadExcelModal';
import { trackDownloadExcelBtnClick } from './tracking';
import { useDownloadExcelFile } from './utils/useDownloadExcelFile';

export const DownloadExcelContainer: React.VFC = () => {
  const profsearchUrl = useSelector(selectProfessionalSearchUrl);
  const isAgent = useSelector(selectIsUserAgent);
  const { state: isModalOpened, setTrue: setModalOpen, setFalse: setModalClose } = useBooleanState(false);
  const { error, handleDownloadExcelFile, isLoading, resetError } = useDownloadExcelFile();

  /** Сбросит ошибку при закрытии модалки */
  React.useEffect(() => {
    if (!isModalOpened) {
      resetError();
    }
  }, [isModalOpened, resetError]);

  const handleOpenModalClick = React.useCallback(() => {
    setModalOpen();
    trackDownloadExcelBtnClick();
  }, [setModalOpen]);

  const DownloadExcelModalComponent = isAgent ? DownloadExcelModalRealtors : DownloadExcelModalSearchers;

  return (
    <>
      <DownloadExcelButton onClick={handleOpenModalClick} />
      <DownloadExcelModalComponent
        isLoading={isLoading}
        isOpened={isModalOpened}
        onClose={setModalClose}
        onDownloadClick={handleDownloadExcelFile}
        error={error}
        profsearchUrl={profsearchUrl}
      />
    </>
  );
};
